const colorList = {
  lilly: "#D7290F",
  roche: "#2D82F0",
  novartis: "#0099FF",
  msd: "#21BDB0",
  merck: "#512E94",
  pfizer: "#E60012",
  dsm: "#00A16D"
}
export default colorList



// WEBPACK FOOTER //
// ./src/config/index.js